module.exports = __webpack_public_path__ + "img/madeline.ded87947.png";